export default __webpack_public_path__ + "static/media/Tv2_oj_2.e260a01b.png";